import { WarningOutlined } from '@ant-design/icons'
import styled from 'styled-components'

const StyledQaCorrectionsIcon = styled(WarningOutlined)`
  margin-left: 8px;
`

export default StyledQaCorrectionsIcon
